module.exports = __webpack_public_path__ + "img/external-link-alt-solid.81198e0a.svg";